import React, { useEffect, useState } from "react";
import Sidebar from "../components/Sidebar";
/* global bootstrap */
import BackButton from "../components/BackButton";

export default function GermanSettings() {
  const [user, setUser] = useState(null);
  const [iframeLoaded, setIframeLoaded] = useState(false);

  useEffect(() => {
    const storedUser = localStorage.getItem("GF_User_Data");
    if (storedUser) {
      setUser(JSON.parse(storedUser));
    }
  }, []);

  if (!user) return null; // or a loading spinner while user is loading

  return (
    <div>
      <Sidebar />
      <div className="main-body">
        <BackButton />
        <h4 className="my-3">
          <strong>Abo Verwaltung</strong>
        </h4>

        {!iframeLoaded && (
          <div className="text-center my-5 pt-5">
            <div className="spinner-border text-secondary" role="status">
              <span className="visually-hidden">Loading iframe...</span>
            </div>
          </div>
        )}

        <iframe
          src={`https://apis.mymobibox.mobi/API/InAppWAP/Uns/?bcid=${user.billingChannelId}&MSISDN=${user.Phone}&langCode=en`}
          style={{
            display: iframeLoaded ? "block" : "none",
            width: "100%",
            height: "80vh",
            border: "none"
          }}
          title="Mobibox Abo Verwaltung"
          onLoad={() => setIframeLoaded(true)}
        />
      </div>
    </div>
  );
}
